"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/studio_recording_main_setup_pinheiros.png",
  alt: "Área principal de gravação com câmeras Blackmagic e iluminação profissional",
  spanClasses: "md:col-span-2 lg:col-span-2 row-span-2"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/studio_shure_sm7b_microphones_detail.png",
  alt: "Microfones Shure SM7B em braços articulados",
  spanClasses: "col-span-1 row-span-1"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/studio_technical_control_room_monitoring.png",
  alt: "Mesa de corte e monitoramento técnico",
  spanClasses: "col-span-1 row-span-2"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/studio_acoustic_treatment_panels_design.png",
  alt: "Tratamento acústico de alta performance",
  spanClasses: "col-span-1 row-span-1"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/studio_podcast_production_set_sao_paulo.png",
  alt: "Cenário de podcast pronto para gravação",
  spanClasses: "md:col-span-2 lg:col-span-2 row-span-1"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/studio_blackmagic_6k_cinema_camera.png",
  alt: "Câmera Blackmagic 6K para máxima qualidade de imagem",
  spanClasses: "col-span-1 row-span-1"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/studio_premium_lounge_reception_area.png",
  alt: "Área de apoio ao estúdio com mobiliário confortável para a equipe",
  spanClasses: "col-span-1 lg:col-span-2 row-span-2"
}];
export default function Gallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const noisePattern = `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`;
  return <section data-section-id="231660" id="nossa-estrutura-em-pinheiros" className="relative py-40 bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-[30rem] h-[30rem] bg-primary/10 rounded-full blur-[150px] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="mb-16 text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold font-serif mb-6 text-foreground">
            Infraestrutura de Elite em Pinheiros
          </h2>
          <p className="text-muted-foreground text-lg">
            Equipamentos de última geração e ambientes projetados para o máximo desempenho audiovisual.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6 auto-rows-[250px] transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {galleryImages.map((item, i) => <div key={i} data-index={i} className={`group relative overflow-hidden rounded-lg bg-muted shadow-sm transition-all duration-500 hover:shadow-xl border border-border/50 ${item.spanClasses}`}>
              {}
              <img src={item.src} alt={item.alt} className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110" loading="lazy" />
              
              {}
              <div className="absolute inset-0 bg-primary/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
              
              {}
              <div className="absolute inset-0 opacity-[0.03] mix-blend-overlay pointer-events-none transition-opacity duration-500 group-hover:opacity-[0.08]" style={{
            backgroundImage: noisePattern
          }} />
              
              {}
              <div className="absolute inset-0 shadow-[inset_0_0_100px_rgba(0,0,0,0.2)] opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />

              {}
              <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 ease-out bg-gradient-to-t from-black/80 to-transparent">
                <span className="inline-block px-4 py-1.5 bg-primary text-primary-foreground font-sans text-xs font-bold rounded-full shadow-lg uppercase tracking-wider">
                  {item.alt}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}